module.exports = __webpack_public_path__ + "static/media/BANNER - questions_V6.d8f89113.jpg";